// Generated by tools/pixellab/pack-hero-art.py from PixelLab output.
export const COMBAT_ART = {
  "dante-roots": {
    "file": "../combat-v2/dante-roots-grasp.png",
    "cols": 4,
    "rows": 3,
    "frames": 12,
    "fps": 6.666666666666666,
    "fill": 0.92
  },
  "gandhi-satyagraha": {
    "file": "../combat-v2/gandhi-satyagraha-effect.png",
    "cols": 5,
    "rows": 5,
    "frames": 24,
    "fps": 20.0,
    "fill": 0.95
  },
  "gandhi-sit": {
    "file": "../combat-v2/gandhi-sit-effect.png",
    "cols": 5,
    "rows": 2,
    "frames": 9,
    "fps": 15.873015873015873,
    "fill": 0.95
  },
  "gandhi-staff": {
    "file": "../combat-v2/gandhi-staff-effect.png",
    "cols": 5,
    "rows": 2,
    "frames": 8,
    "fps": 27.027027027027028,
    "fill": 0.95
  }
} as const;
